import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "energy",
  "use": "energy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"energy\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.25 4.5H1.75V12.6893L3.31066 14.25H12.6893L14.25 12.6893V4.5H15.75V13.3107L13.3107 15.75H2.68934L0.25 13.3107V4.5Z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.88574 6.56982L8.38574 1.56982L9.61459 2.43002L7.18725 5.89765L10.3531 5.26449L11.0858 6.46844L7.08582 11.4684L5.91451 10.5314L8.62832 7.13914L5.64725 7.73536L4.88574 6.56982Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol